import React, { Component } from 'react'
import { Map } from 'immutable'
import { connect } from 'react-redux'

function mapStateToProps(state) {
    return {
        loaders: state.getIn(['ui', 'loader'], Map()),
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
